import { render, staticRenderFns } from "./EditarPost.vue?vue&type=template&id=33d9cf0b&scoped=true&"
import script from "./EditarPost.vue?vue&type=script&lang=js&"
export * from "./EditarPost.vue?vue&type=script&lang=js&"
import style0 from "./EditarPost.vue?vue&type=style&index=0&id=33d9cf0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d9cf0b",
  null
  
)

export default component.exports